<template>
  <v-container class="sancionados">
    <v-card class="py-4 px-2 auth-content" tile>
      <v-form v-model="valid" ref="form">
        <PageTitle main="Transparência" icon="mdi-pencil-box-outline" sub="Fornecedores sancionados" home="/transparencia" />
        <input id="user-id" type="hidden" v-model="convenio.usuario" />
        <input id="convenio-id" type="hidden" v-model="convenio.id" />
        <v-row>
          <v-col cols="12" md="3" lg="2">
            <v-text-field v-model="codigo" label="Código" dense outlined>
              <v-icon slot="append" color="success" large @click="loadDialog">
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-mask="mask_ini" v-model="data_dtIni" label="Início sanção.:" dense outlined
                  @blur="mudaDataA">
                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker locale="pt-br" v-model="date0" @input="DateA">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-mask="mask_fim" v-model="data_fim" label="Final da sanção.:" dense outlined
                  @blur="mudaDataB">
                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker locale="pt-br" v-model="date1" @input="DateB">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3" lg="2" v-if="codigo">
            <v-checkbox v-model="convenio.inativar" label="Inativar sanção?" color="success"
              v-show="mode === 'save'"></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              lg="2"
              md="2"
              sm="12"
            >
              <v-autocomplete
                v-model="convenio.tipo_pessoa"
                :items="tPessoa"
                label="Tipo de pessoa"
                required
                outlined
                dense
                @change="loadFuncaoPessoa()"
              ></v-autocomplete>
            </v-col>
            <input
              id="pessoa-cgc"
              type="hidden"
              v-model="convenio.cgc"
            />
          <v-col
              cols="12"
              lg="2"
              md="3"
              sm="12"
              v-if="inputcpf === true"
            >
              <div v-if="verCpf === true">
                <v-text-field
                  v-model="convenio.cgc_txt"
                  clearable
                  v-mask="cpf"
                  label="CPF"
                  :error="error"
                  :error-messages="message"
                  outlined
                  dense
                  required
                  @blur="formataCpf()"
                  @focus="limpaValidacao()"
                >
                </v-text-field>
              </div>
              <div v-if="verCnpj === true">
                <v-text-field
                  v-model="convenio.cgc_txt"
                  clearable
                  v-mask="cnpj"
                  label="CNPJ"
                  :error="error"
                  :error-messages="message"
                  outlined
                  dense
                  required
                  @blur="formataCnpj()"
                  @focus="limpaValidacao()"
                >
                </v-text-field>
              </div>
            </v-col>
          <v-col cols="12" md="6" lg="5">
            <v-text-field v-model="convenio.nome" :label="`${nameLabel}`" required dense outlined></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="5" lg="4">
            <v-autocomplete v-model="convenio.uid_tipo_sancao" :items="categorias" required dense outlined
              label="Tipo de sanção"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-autocomplete v-model="convenio.uid_abrangencia" :items="catEsfera" required dense outlined
              label="Abrangência"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <v-text-field v-model="convenio.ano_inscricao" label="Ano da inscrição" required dense outlined></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" lg="5">
            <v-autocomplete v-model="convenio.uid_orgao" :items="catEsfera" required dense outlined
              label="Órgão sancionador"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <v-text-field v-model="convenio.nr_processo" label="Nº processo" required dense outlined></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="10">
            <v-textarea
              v-model="convenio.motivo"
              label="Motivo da sanção"
              row-height="15"
              rows="2"
              dense
              outlined
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="10">
            <v-textarea
              v-model="convenio.ds_motivo"
              label="Observações adicionais"
              row-height="15"
              rows="2"
              dense
              outlined
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs background-color="primary" dark v-model="tabs">
            <v-tab>
              <v-icon class="mr-1">
                mdi-cog-sync
              </v-icon>
              Carga
            </v-tab>
            <v-tab @click="loadAnexos">
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              Anexos
            </v-tab>
            <v-tab>
            <v-icon class="mr-1">
                mdi-calendar-alert
              </v-icon>
              Publicação
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12" class="py-8">
                    Cargar dados da API Prodata<v-spacer class="ml-6"></v-spacer><span class="text-red-lighten-1">Atenção para realizar esta operação os campos data início e data fim são obrigatórios</span>
                    <v-card>
                      <v-container>
                        <v-form>
                          <v-row>
                            <v-col cols="12" md="3" lg="4">
                              <v-autocomplete v-model="sync.orgao" :items="categorias" required dense outlined
                                label="Tipo de convênio"></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row class="mt-1">
                            <v-col cols="12" md="6">
                              <v-btn color="success" class="ml-1 mr-4" @click="syncDados">
                                <v-icon left>
                                  mdi-table-sync
                                </v-icon>
                                Carregar
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    <v-card>
                      <v-data-table :headers="headersAnexos" :items="anexos" :search="search">
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon medium color="primary" class="mr-2" @click="loadAnexo(item)">
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon medium color="error" class="mr-2" @click="loadAnexo(item, 'remove')">
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-btn color="success" class="ml-1 mb-3" v-if="codigo" @click="AddAnexo">
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add anexo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col cols="12" md="12" class="py-8">
                    <v-card-sub-title class="px-2">Publicação do convênio</v-card-sub-title>
                    <v-card>
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="4" lg="3">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                              offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-mask="mask_pub" v-model="data_pub" label="Data de publicação.:" dense outlined
                                  @blur="mudaDataC">
                                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker locale="pt-br" v-model="date2" @input="DateC">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" lg="3">
                            <v-checkbox v-model="convenio.publicado" label="Publicar este convênio?" color="success"
                              v-show="mode === 'save'"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="4" lg="3">
                            <v-btn color="success" class="ml-1 mr-4" @click="publicar">
                              <v-icon left>
                                mdi-content-save
                              </v-icon>
                              Publicar
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-1">
          <v-col cols="12" md="6">
            <v-btn :disabled="!valid" color="success" class="ml-1 mr-4" v-if="mode === 'save'" @click="save">
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn color="error" class="mr-4" v-if="mode === 'remove'" @click="remove">
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn color="secondary" class="mr-4" @click="reset">
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog v-model="dialog" transition="dialog-bottom-transition" fullscreen>
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar color="primary" dark>
                  Pesquisar convenios
                </v-toolbar>
                <v-card-title>
                  <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Pesquisar" single-line
                    hide-details>
                  </v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="convenios" :search="search">
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon medium color="primary" class="mr-2" @click="loadConvenio(item)">
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon medium color="error" class="mr-2" @click="loadConvenio(item, 'remove')">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn color="error" @click="dialog.value = false">Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog v-model="DialogAnexo" transition="dialog-top-transition">
          <v-card class="py-4 px-2 auth-content" tile>
            <div class="logo-foto ml-4 mt-5">
              <v-form v-model="valid" ref="form" class="altura">
                <PageTitle icon="mdi-pencil-box-outline" sub="Adicionar anexo" />
                <input id="user-id" type="hidden" v-model="anexo.usuario" />
                <input id="anexo-id" type="hidden" v-model="anexo.id" />
                <v-row>
                  <v-col cols="12" md="7" lg="8">
                    <v-text-field v-model="anexo.nome" type="text" label="Nome do arquivo" outlined dense>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" lg="4">
                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-mask="datpd" v-model="date_pubDoc" label="Data de publicacao.:" dense outlined
                          @blur="mudaDataD">
                          <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker locale="pt-br" v-model="date3" @input="DateD">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <input accept="application/vnd.ms-excel, application/pdf" prepend-icon="mdi-camera" label="Anexo"
                    v-if="uploadReady" type="file" ref="file" @change="selectFile()">
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn color="success" class="mr-4" v-if="codigo" type="submit" @click.prevent="fileUpload()">
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn color="error" class="mr-4" v-if="codigo" @click="clearUpload">
                Remover
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn color="danger" class="mr-4" @click="FecharDialog">
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
const { cpf, cnpj } = require('cpf-cnpj-validator')
export default {
  name: 'Sancionados',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    mask_ini: '##/##/####',
    mask_fim: '##/##/####',
    mask_pub: '##/##/####',
    mask_pubDoc: '##/##/####',
    datpd: '##/##/####',
    tabs: null,
    codigo: '',
    cpf: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    cgccpf: '',
    inputcpf: true,
    nameLabel: '',
    color: 'null',
    error: false,
    message: '',
    dialog: false,
    DialogAnexo: false,
    loading: false,
    uploadReady: true,
    file: '',
    tabela: 'anexos_convenio',
    pasta: 'convenio',
    search: null,
    select: null,
    date0: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    date3: new Date().toISOString().substr(0, 10),
    data_dtIni: '',
    data_fim: '',
    data_pub: '',
    date_pubDoc: '',
    menu: false,
    menu1: false,
    menu2: false,
    menu3: false,
    mode: 'save',
    convenio: {},
    sync: {},
    dados: {},
    anexo: {},
    tPessoa: [],
    categorias: [],
    anexos: [],
    convenios: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nr. convênio', value: 'convenio' },
      { text: 'Concedente', value: 'concedente' },
      { text: 'Beneficiário', value: 'convenente' },
      { text: 'Publicação', value: 'data' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAnexos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Tabela', value: 'tabela' },
      { text: 'pasta', value: 'pasta' },
      { text: 'Data', value: 'dtMaskub' },
      { text: 'Link', value: 'url' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    catEsfera: [
      { value: 1, text: 'Municipal' },
      { value: 2, text: 'Estadual' },
      { value: 3, text: 'Federal' }
    ],
    valid: false
  }),
  methods: {
    loadFuncaoPessoa (tipo) {
      const codigo = this.codigo
      const pessoa = tipo || this.convenio.tipo_pessoa
      if (pessoa === 1) {
        if (codigo === '') {
          this.verCpf = true
        } else {
          this.verCpf = false
        }
        this.verCnpj = false
        this.tipo = 'pfisica'
        this.nameLabel = 'Nome do sancionado*'
      } else if (pessoa === 2) {
        if (codigo === '') {
          this.verCnpj = true
        } else {
          this.verCnpj = false
        }
        this.verCpf = false
        this.tipo = 'pjuridica'
        this.nameLabel = 'Razão social do sancionado*'
      }
    },
    formataCpf () {
      const cpff = this.convenio.cgc_txt
      const ccpf = cpf.isValid(cpff)
      const number = cpf.strip(cpff)
      console.log(number + '-' + ccpf)
      if (ccpf === true) {
        this.convenio.cgc = number
        this.error = false
        // this.btnSave = true
      } else {
        this.error = true
        this.message = `O CPf informado é inválido!`
      }
    },
    formataCnpj () {
      const cnpjj = this.convenio.cgc_txt
      const ccnpj = cnpj.isValid(cnpjj)
      const number = cnpj.strip(cnpjj)
      if (ccnpj === true) {
        this.convenio.cgc = number
        this.error = false
        // this.btnSave = true
      } else {
        this.error = true
        this.message = `O CNPJ informado é inválido!`
      }
    },
    limpaValidacao () {
      this.error = false
      this.message = ''
    },
    DateA () {
      this.data_dtIni = moment(this.date0).format('DD/MM/YYYY')
      this.menu = false
      this.mudaDataA()
    },
    mudaDataA () {
      if (!this.data_dtIni) return
      const data = moment(this.data_dtIni, 'DD/MM/YYYY', true)
      if (!data.isValid()) return

      this.convenio.inicio = data.format('YYYY-MM-DD')
    },
    DateB () {
      this.data_fim = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      this.mudaDataB()
    },
    mudaDataB () {
      if (!this.data_fim) return
      const data = moment(this.data_fim, 'DD/MM/YYYY', true)
      if (!data.isValid()) return

      this.convenio.termino = data.format('YYYY-MM-DD')
    },
    DateC () {
      this.data_pub = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      this.mudaDataC()
    },
    mudaDataC () {
      if (!this.data_pub) return
      const data = moment(this.data_pub, 'DD/MM/YYYY', true)
      if (!data.isValid()) return

      this.convenio.publicacao = data.format('YYYY-MM-DD')
    },
    DateD () {
      this.date_pubDoc = moment(this.date3).format('DD/MM/YYYY')
      this.menu3 = false
      this.mudaDataD()
    },
    mudaDataD () {
      if (!this.date_pubDoc) return
      const data = moment(this.date_pubDoc, 'DD/MM/YYYY', true)
      if (!data.isValid()) return

      this.anexo.publicacao = data.format('YYYY-MM-DD')
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      const method = this.convenio.id ? 'put' : 'post'
      const id = this.convenio.id ? `/${this.convenio.id}` : ''
      axios[method](`${baseApiUrl}/convenios/convenio${id}`, this.convenio)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    publicar () {
      const id = this.convenio.id
      const method = 'put'
      this.dados.publicacao = this.convenio.publicacao
      this.dados.publicado = this.convenio.publicado
      axios[method](`${baseApiUrl}/convenios/publicar/${id}`, this.dados)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    syncDados () {
      this.sync.dataInicial = this.date0
      this.sync.dataFinal = this.date2
      this.sync.ano = this.convenio.ano_referencia
      const method = 'post'
      axios[method](`${baseApiUrl}/carga-prodata-convenios-sync`, this.sync)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`
      formData.append('uid_convenio', this.convenio.id)
      formData.append('data_publicacao', this.anexo.publicacao)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.pasta)
      formData.append('subpasta', this.convenio.id)
      formData.append('usuario', this.anexo.usuario)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.anexo = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    saveAnexo () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      axios[method](`${baseApiUrl}/anexos${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadAnexos()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadAnexos () {
      const id = this.convenio.id
      const url = `${baseApiUrl}/anexos-do-convenio/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            dtMaskub: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadConvenios () {
      const url = `${baseApiUrl}/convenios/filtros`
      axios.get(url).then(res => {
        this.convenios = res.data.map(item => {
          return {
            ...item,
            data: moment(item.publicacao).format('DD/MM/YYYY'),
            convenio: (item.nr_convenio + '/' + item.ano)
          }
        })
      })
    },
    loadCategorias () {
      const url = `${baseApiUrl}/categorias`
      axios.get(url).then(res => {
        this.categorias = res.data.map(cat => {
          return { value: cat.id, text: `${cat.categoria}` }
        })
      })
    },
    loadPessoa () {
      const url = `${baseApiUrl}/lista-tipo-de-pessoa`
      axios.get(url).then(res => {
        this.tPessoa = res.data.map(tPessoa => {
          return {
            value: tPessoa.id,
            text: `${tPessoa.id} - ${tPessoa.tipo}`
          }
        })
      })
    },
    loadConvenio (item, mode = 'save') {
      const id = item.id
      const url = `${baseApiUrl}/convenios/filtro-update/${id}`
      axios.get(url).then(res => {
        this.convenio = res.data
        this.data_dtIni = moment(this.convenio.inicio).format('DD/MM/YYYY')
        this.data_fim = moment(this.convenio.termino).format('DD/MM/YYYY')
        this.data_pub = moment(this.convenio.publicacao).format('DD/MM/YYYY')
        this.codigo = this.convenio.id
        this.loadDatas()
      })
      this.mode = mode
      this.dialog = false
      this.valid = true
    },
    loadAnexo (anexo, mode = 'save') {
      this.mode = mode
      this.anexo = { ...anexo }
      this.anexo.usuario = this.user.id
      this.DialogAnexo = true
    },
    AddAnexo () {
      this.anexo.usuario = this.user.id
      this.anexo.uid_convenio = this.convenio.id
      this.DialogAnexo = true
    },
    reset () {
      this.$refs.form.reset()
      this.valid = true
      this.mode = 'save'
      this.convenio = {}
      this.convenio.usuario = this.user.id
    },
    limpar () {
      this.mode = 'save'
      this.anexo = {}
      this.anexo.usuario = this.user.id
      this.anexo.uid_convenio = this.convenio.id
    },
    FecharDialog () {
      this.DialogAnexo = false
      this.limpar()
    },
    adicionarAnexo () {
      this.saveAnexo()
    },
    adicionarAnexoSair () {
      this.saveAnexo()
      this.DialogAnexo = false
    },
    loadDialog () {
      this.dialog = true
      this.loadConvenios()
    },
    loadDatas () {
      this.mudaDataA()
      this.mudaDataB()
      this.mudaDataC()
      // this.mudaDataD()
    },
    loadUser () {
      const tipo = 2
      this.convenio.tipo_pessoa = 2
      this.loadPessoa()
      this.convenio.usuario = this.user.id
      this.loadFuncaoPessoa(tipo)
    }
  },
  mounted () {
    this.loadUser()
    this.loadCategorias()
  }
}
</script>

<style scoped>
.altura {
  min-height: 380px !important;
}

.text-v-card {
  font-size: 1rem !important;
}

.codigo {
  max-width: 100% !important;
}

.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}

.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}

.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}

ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}

ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}

ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}

ul.filtro li a:hover {
  color: #ffffff !important;
}

.container {
  width: 98% !important;
}

.logo-foto {
  max-width: 750px;
}
</style>
